import type { Template } from '@commons/components/RichText/templates';
import Separator from '@commons/components/Separator';

/**
 * Small dash CKEditor template.
 *
 * @returns A rendered React component.
 */

const SmallDashTemplate: Template = () => (
  <Separator dash dashSize="sm" color="primary" marginBottom="xxs" />
);

export default SmallDashTemplate;
